
import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { finalize } from 'rxjs';
import Swal from 'sweetalert2';

import {
  UsuariosService,
  Usuario
} from '../../../core/services/usuarios.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css'
})
export class ParceiroDashboard implements OnInit {

  private api = inject(UsuariosService);
  private cdr = inject(ChangeDetectorRef);

  usuarios: Usuario[] = [];

  erro = '';
  loading = false;

  get ativos(): Usuario[] {
    return this.usuarios.filter(
      u => u.ativo !== false && !!u.plano
    );
  }

  ngOnInit(): void {
    this.carregarUsuarios();
  }

  carregarUsuarios(): void {

    if (this.loading) return;

    this.loading = true;
    this.erro = '';

    this.api.listar()
      .pipe(
        finalize(() => {
          this.loading = false;
          this.cdr.detectChanges();
        })
      )
      .subscribe({
        next: (usuarios) => {
          this.usuarios = usuarios ?? [];
          this.cdr.detectChanges();
        },

        error: (error) => {
          console.error(
            'Erro ao carregar dashboard do parceiro:',
            error
          );

          this.erro = 'Não foi possível carregar os usuários.';

          this.cdr.detectChanges();

          void Swal.fire({
            icon: 'error',
            title: 'Erro ao carregar dashboard',
            text: 'Não foi possível buscar os usuários vinculados. Tente novamente.',
            confirmButtonText: 'Entendi',
            confirmButtonColor: '#064F82'
          });
        }
      });
  }
}
